import React from "react";
import Icon from "../icons/Icon";

function RefreshButton({ onClick, loading }) {
  return (
    <button
      className={loading ? "btn btn-disabled" : "btn btn-secondary"}
      type="button"
      disabled={loading}
      onClick={onClick}
    >
      <Icon name="refresh-cw" />
      Atualizar
    </button>
  );
}

export default RefreshButton;
